import { Text, SvgIcon } from '@cinch-labs/design-system'
import { IconNames } from '@cinch-labs/design-system/dist/src/tokens/tokens.types'

export interface IconWithTextProps {
  icon: IconNames
  text: string
}

export const IconWithText = ({ icon, text }: IconWithTextProps) => (
  <div>
    <SvgIcon name={icon} size={16} />
    <Text>{text}</Text>
  </div>
)
